<template>
<!-- 页头 -->
  <div class="top">
    <header class="flex_two_center" style="height: 60px">
      <img style="width: 150px" src='@/image/logo.png'/>
    </header>

    <div @click="changeDrawer">
      <img class='icon' v-if="!drawer" src='@/image/icon/menu.png'/>
      <img class='icon' v-else src='@/image/icon/cha.png'/>
    </div>
    
    <!-- 菜单抽屉 -->
    <el-drawer
      class='menu'
      size='40%'
      :direction="direction"
      :visible.sync="drawer"
      :with-header="false"
      :modal='false'>
      <el-menu :default-active="$route.path" router active-text-color="#55A2FF">
        <el-menu-item index="/" @click="changeDrawer">首页</el-menu-item>
        <el-divider></el-divider>
        <el-menu-item index="/products" @click="changeDrawer">产品</el-menu-item>
        <el-divider></el-divider>
        <el-menu-item index="/solution" @click="changeDrawer">解决方案</el-menu-item>
        <el-divider></el-divider>
        <el-menu-item index="/about" @click="changeDrawer">关于我们</el-menu-item>
        <el-divider></el-divider>
        <el-menu-item index="/services" @click="changeDrawer">服务支持</el-menu-item>
        <el-divider></el-divider>
      </el-menu>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      drawer: false,// 控制菜单是否出现
      direction:'ttb',// 控制菜单从左到右出现
    }
  },
  methods: {
    changeDrawer() {
      this.drawer = !this.drawer;
    },
  },
  created() {
    // 打印出来要和上面的路径一模一样才会高亮
    // console.log(this.$route.path,'111')
  },
}
</script>

<style lang="scss" scoped>
.top {
  background-color: #ffffff;
  height: 60px;
  line-height: 60px;
  position: relative;
  border-bottom: 1px solid #CCCCCC;
  .icon {
    width:24px;
    position: absolute;
    top: 18px;
    left: 15px;
  }
  .menu {
    position:absolute;
    left: 0;
    top:60px;
    border-top:1px solid #F2F2F2;
    margin-top:-1px;
    height: calc(100vh - 60px);
    overflow-y: auto;
  }
}
.el-menu-item {
  color: #868585;
}
.el-divider--horizontal {
  margin: 0; 
  width: 95%;
  margin:auto;
}
</style>